import axiosInstance, { apiBase } from './apiBase'
import { api } from '../utils/api'

const withStoreDate = ({ storeId, date, ...rest }) => ({
	storeId,
	date,
	...rest,
})

export const cashflowService = {
	getSummary: ({ storeId, date }) => apiBase.get(api.CASHFLOW_SUMMARY, withStoreDate({ storeId, date })),
	// Thống kê cửa hàng tính doanh thu theo đường riêng, dùng để đối chiếu với số thu của báo cáo ngày.
	// Admin xem được mọi cửa hàng, còn lại chỉ xem cửa hàng của mình.
	getOrderStatistics: ({ storeId, date, isAdminLike }) => {
		const [year, month, day] = String(date || '').split('-')
		const params = { shift: '', date: String(Number(day)), month: String(Number(month)), year }
		return isAdminLike
			? apiBase.get(`${api.GET_STATISTICS_BY_STORE_ADMIN}/${storeId}`, params)
			: apiBase.get(api.GET_STATISTICS_STORE_MANAGER, params)
	},
	getReports: ({ storeId, from, to }) => apiBase.get(api.CASHFLOW_REPORTS, { storeId, from, to }),
	getBankAccounts: ({ storeId, includeInactive } = {}) =>
		apiBase.get(api.CASHFLOW_BANK_ACCOUNTS, { storeId, includeInactive }),
	createBankAccount: (payload) => apiBase.post(api.CASHFLOW_BANK_ACCOUNTS, payload),
	createDefaultBankAccounts: (payload) => apiBase.post(`${api.CASHFLOW_BANK_ACCOUNTS}/defaults`, payload),
	updateBankAccount: (accountId, payload) => apiBase.put(`${api.CASHFLOW_BANK_ACCOUNTS}/${accountId}`, payload),
	deleteBankAccount: (accountId) => apiBase.delete(`${api.CASHFLOW_BANK_ACCOUNTS}/${accountId}`),
	getExpenseCategories: ({ storeId, type, includeInactive } = {}) =>
		apiBase.get(api.CASHFLOW_EXPENSE_CATEGORIES, { storeId, type, includeInactive }),
	createDefaultExpenseCategories: (payload) => apiBase.post(api.CASHFLOW_EXPENSE_CATEGORY_DEFAULTS, payload),
	createExpenseCategory: (payload) => apiBase.post(api.CASHFLOW_EXPENSE_CATEGORIES, payload),
	updateExpenseCategory: (categoryId, payload) =>
		apiBase.put(`${api.CASHFLOW_EXPENSE_CATEGORIES}/${categoryId}`, payload),
	deleteExpenseCategory: (categoryId) => apiBase.delete(`${api.CASHFLOW_EXPENSE_CATEGORIES}/${categoryId}`),
	getExpenses: ({ storeId, date, type }) => apiBase.get(api.CASHFLOW_EXPENSES, withStoreDate({ storeId, date, type })),
	createExpense: (formData) =>
		axiosInstance.post(api.CASHFLOW_EXPENSES, formData, {
			headers: { 'Content-Type': 'multipart/form-data' },
		}),
	updateExpense: (expenseId, formData) =>
		axiosInstance.put(`${api.CASHFLOW_EXPENSES}/${expenseId}`, formData, {
			headers: { 'Content-Type': 'multipart/form-data' },
		}),
	confirmExpense: (expenseId) => apiBase.put(`${api.CASHFLOW_EXPENSES}/${expenseId}/confirm`),
	deleteExpense: (expenseId) => apiBase.delete(`${api.CASHFLOW_EXPENSES}/${expenseId}`),
	getIncomes: ({ storeId, date, receiptType }) =>
		apiBase.get(api.CASHFLOW_INCOMES, withStoreDate({ storeId, date, receiptType })),
	createIncome: (formData) =>
		axiosInstance.post(api.CASHFLOW_INCOMES, formData, {
			headers: { 'Content-Type': 'multipart/form-data' },
		}),
	updateIncome: (incomeId, formData) =>
		axiosInstance.put(`${api.CASHFLOW_INCOMES}/${incomeId}`, formData, {
			headers: { 'Content-Type': 'multipart/form-data' },
		}),
	deleteIncome: (incomeId) => apiBase.delete(`${api.CASHFLOW_INCOMES}/${incomeId}`),
	autoAssignOrderAccounts: (payload) => apiBase.post(`${api.CASHFLOW_ORDERS}/auto-assign-accounts`, payload),
	assignOrderAccount: (orderId, payload) => apiBase.put(`${api.CASHFLOW_ORDERS}/${orderId}/account`, payload),
	linkOrderIncomeOffset: (orderId, payload) =>
		apiBase.post(`${api.CASHFLOW_ORDERS}/${orderId}/income-offsets`, payload),
	unlinkOrderIncomeOffset: (orderId, incomeId, payload = {}) =>
		apiBase.delete(`${api.CASHFLOW_ORDERS}/${orderId}/income-offsets/${incomeId}`, payload),
	getPaymentSourceAccounts: (orderId, payload = {}) =>
		apiBase.get(`${api.CASHFLOW_ORDERS}/${orderId}/payment-source-accounts`, payload),
	getPaymentConfirmations: ({ storeId, date, status }) =>
		apiBase.get(api.CASHFLOW_PAYMENT_CONFIRMATIONS, { storeId, date, status }),
	createPaymentConfirmation: (payload) => apiBase.post(api.CASHFLOW_PAYMENT_CONFIRMATIONS, payload),
	confirmPaymentConfirmation: (confirmationId) =>
		apiBase.put(`${api.CASHFLOW_PAYMENT_CONFIRMATIONS}/${confirmationId}/confirm`),
	rejectPaymentConfirmation: (confirmationId, payload) =>
		apiBase.put(`${api.CASHFLOW_PAYMENT_CONFIRMATIONS}/${confirmationId}/reject`, payload),
	deletePaymentConfirmation: (confirmationId) =>
		apiBase.delete(`${api.CASHFLOW_PAYMENT_CONFIRMATIONS}/${confirmationId}`),
	submitDailyReport: (formData) =>
		axiosInstance.post(api.CASHFLOW_DAILY_REPORT, formData, {
			headers: { 'Content-Type': 'multipart/form-data' },
		}),
		getFilePdf : (formData)=>
			axiosInstance.post(api.CASHFLOW_DAILY_REPORT_PDF, formData, {
				headers: { 'Content-Type': 'multipart/form-data' },
			}),
	submitAccountVerification: (formData) =>
		axiosInstance.post(api.CASHFLOW_DAILY_REPORT, formData, {
			headers: { 'Content-Type': 'multipart/form-data' },
		}),
	getShippingOrders: ({ storeId, date }) => apiBase.get(api.CASHFLOW_SHIPPING_ORDERS, withStoreDate({ storeId, date })),
}

export default cashflowService
